import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import { Button, Checkbox, TextField } from '@mui/material';
import Modal from '@mui/material/Modal';
import React, { useContext } from 'react';
import CardBlock from '@/components/CardBlock/CardBlock';
import Grid from '@mui/material/Grid';
import Input from '@mui/material/Input';
import FormControlLabel from '@mui/material/FormControlLabel';
import { MeetupContext } from '@/MeetupContext';
import { Link, useParams } from 'react-router-dom';
import { Link as LinkCore } from '@mui/material';
import FormLabel from '@mui/material/FormLabel';
import doc_links from 'common/doc_links';
import RadioGroup from '@mui/material/RadioGroup';
import { RegFormType, SystemFieldType } from '@/api';
import Radio from '@mui/material/Radio';
import { useForm } from 'react-hook-form';
import { ECTextField } from '@/components/Forms/ECTextField';
import { ECRadioGroupField } from '@/components/Forms/ECRadioGroupField';
import { fieldKey } from '../../VisitorList/components/ImportXLS/import_utils';
import { ECMultiCheckboxField } from '@/components/Forms/ECMultiCheckboxField';
import * as _ from 'underscore';

const PREFIX = 'RegFormSettings';

const classes = {
  groupLabel: `${PREFIX}-groupLabel`,
};

const StyledCardBlock = styled(CardBlock)(({ theme }) => ({
  [`& .${classes.groupLabel}`]: {
    paddingTop: 12, //theme.spacing(1)
  },
}));

const RegFormSettings = props => {
  const { className, fields, regForm, save, ...rest } = props;
  const { mid: meetupId } = useParams();

  const form = useForm();

  const handleSave = data => {
    save(data, form);
  };

  return (
    <StyledCardBlock
      title={'Настройка формы регистрации'}
      form={form}
      save={handleSave}
      hint={
        <LinkCore
          href={doc_links.customFormIntegration}
          target={'_blank'}
        >
          Как настроить отправку данных из своей формы?
        </LinkCore>
      }
    >
      <Grid container spacing={0} sx={{ margin: '-12px' }}>
        {/*<Grid xs={4} className={classes.groupLabel}>*/}
        {/*  <FormLabel component="legend">Тип формы:</FormLabel>*/}
        {/*</Grid>*/}
        {/*<Grid xs={8}>*/}
        {/*  <ECRadioGroupField row name={"formType"} form={form} initial={regForm} options={[*/}
        {/*    {id:RegFormType.Flat, name:"Плоский"},*/}
        {/*    {id:RegFormType.Bar, name:"Квадратный"},*/}
        {/*  ]}/>*/}
        {/*</Grid>*/}

        <Grid className={classes.groupLabel} size={4}>
          <FormLabel component='legend'>Язык:</FormLabel>
        </Grid>
        <Grid size={8}>
          <ECRadioGroupField
            row
            name={'language'}
            form={form}
            initial={regForm}
            options={[
              { id: 'ru', name: 'ru' },
              { id: 'en', name: 'en' },
            ]}
          />
        </Grid>

        <Grid className={classes.groupLabel} size={4}>
          <Typography>Заполняемые поля:</Typography>
        </Grid>
        <Grid size={8}>
          <ECMultiCheckboxField
            name={'fieldsToHide'}
            form={form}
            initial={regForm}
            invert={true}
            options={fields
              .filter(f => f.systemField !== SystemFieldType.QrToken)
              .map(f => {
                return { id: fieldKey(f), name: f.label };
              })}
          />
          <Typography>
            Поля добавляются в{' '}
            <Link style={{ cursor: 'pointer' }} to={`/m/${meetupId}/settings`}>
              Настройках полей
            </Link>
          </Typography>
        </Grid>

        <Grid className={classes.groupLabel} size={4}>
          <Typography>Сообщение об успешной регистрации:</Typography>
        </Grid>
        <Grid size={8}>
          <ECTextField label='' name='completionText' initial={regForm} form={form} multiline rows={4} />
        </Grid>
      </Grid>
    </StyledCardBlock>
  );
};

export default RegFormSettings;
